<button *ngIf="value !== null && value !== undefined && value !== ''" type="button" class="copy-button"
  [matTooltip]="'Copy ' + label" [attr.aria-label]="'Copy ' + label" (click)="copy($event)">
  <mat-icon>content_copy</mat-icon>
</button>
